import { lazy } from 'react';

export const GrammarTrainerDashboardPage = lazy(() => import('./GrammarTrainerDashboardPage'));
